module.exports = __webpack_public_path__ + "static/media/step2img2.60391fcf.jpg";